import { HStack, Text, UI, VStack } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import { FixedFeeNewContractStepOneData } from '../../../../types';

interface StepTwoContractInfoProps {
  stepOneData: FixedFeeNewContractStepOneData;
}

export const StepTwoContractInfo: React.FC<StepTwoContractInfoProps> = ({ stepOneData }) => {
  const infoRows = [
    {
      label: 'Nome do cliente',
      value: stepOneData.selectedCustomer?.customerNameNormalized || '--',
    },
    {
      label: 'Conta de custódia',
      value: stepOneData.selectedCustomer?.custodyAccountNormalized || '--',
    },
    { label: 'Taxa de Fee Fixo', value: Utils.Mask.Percentage(stepOneData.rate) },
  ];

  return (
    <>
      <Text variant="semibold">Dados do contrato</Text>
      <VStack
        space="stack.nano"
        px="inline.xxs"
        py="stack.xxxs"
        borderRadius={BoxBorder.heavy}
        backgroundColor={Utils.ColorToken.WithOpacity('brand.tertiary.lightest', 0.3)}>
        {infoRows.map((item) => (
          <HStack key={item.label} justifyContent="space-between">
            <UI.Text color="neutral.dark">{item.label}</UI.Text>
            <UI.Text variant="semibold" color="neutral.black">
              {item.value}
            </UI.Text>
          </HStack>
        ))}
      </VStack>
    </>
  );
};
